import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AssessmentRef } from "./AssessmentRef";
import type { AssessmentStaff } from "./AssessmentStaff";
import type { SkillAssessmentDTOBase } from "./SkillAssessmentDTOBase";
import type { SkillRef } from "./SkillRef";
import type { SkillStaff } from "./SkillStaff";
import type { TrackedBase } from "./TrackedBase";

export class SkillAssessmentStaff implements SkillAssessmentDTOBase, TrackedBase {
  constructor(public readonly rowId: number, public readonly skillId: SkillStaff | null, public readonly assessmentId: AssessmentStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly skillIdTargetIds: SkillRef, public readonly assessmentIdTargetIds: AssessmentRef) {
    this.cbiServiceContext = null;
    this.skillIdLoaded = this.skillId != null;
    this.skillIdCached = this.skillId;
    this.assessmentIdLoaded = this.assessmentId != null;
    this.assessmentIdCached = this.assessmentId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private skillIdLoaded: boolean;
  private skillIdCached: SkillStaff | null;
  private assessmentIdLoaded: boolean;
  private assessmentIdCached: AssessmentStaff | null;
  async skillIdLazy(): Promise<SkillStaff> {
    if (!this.skillIdLoaded) {
      this.skillIdCached = await this.cbiServiceContext!.personService().getSkillStaff(this.skillIdTargetIds.skillId);
      this.skillIdLoaded = true;
    }
    return this.skillIdCached!;
  }
  async assessmentIdLazy(): Promise<AssessmentStaff> {
    if (!this.assessmentIdLoaded) {
      this.assessmentIdCached = await this.cbiServiceContext!.personService().getAssessmentStaff(this.assessmentIdTargetIds.assessmentId);
      this.assessmentIdLoaded = true;
    }
    return this.assessmentIdCached!;
  }
}
